import React from 'react';
import styles from './A_Indicator.module.css';
import cn from 'classnames';

interface A_IndicatorProps {
  count: number;
  icon: React.ReactNode;
}

export default function A_Indicator({ count, icon }: A_IndicatorProps) {
  return (
    <div className={styles.wrapper}>
      {icon}
      <span className={cn(styles.text, 'text-p-7')}>{count}</span>
    </div>
  );
}
